<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  <form #tmefConfigForm="ngForm">
    <div class="fluid-container">
      <div class="form-group mt-3">
        <label>Entity Type ID*</label>
        <input class="form-control" type="number" name="entityTypeId" [(ngModel)]="rowData.ENTITY_TYPE_ID" required>
        @if (tmefConfigForm.form?.get('entityTypeId')?.invalid && tmefConfigForm.form?.get('entityTypeId')?.touched) {
<span class="form-error-container">
          Entity type ID is required.
        </span>
}
      </div>
      <div class="form-group mt-3">
        <label>Form*</label>
        <input class="form-control" type="text" name="element" [(ngModel)]="rowData.FORM" required>
        @if (tmefConfigForm.form?.get('element')?.invalid && tmefConfigForm.form?.get('element')?.touched) {
<span class="form-error-container">
          Form is required.
        </span>
}
      </div>
      <div class="form-group mt-3">
        <label>Parent Element*</label>
        <input class="form-control" type="text" name="value" [(ngModel)]="rowData.PARENT_ELEMENT_NAME" required>
        @if (tmefConfigForm.form?.get('value')?.invalid && tmefConfigForm.form?.get('value')?.touched) {
<span class="form-error-container">
          Parent element is required.
        </span>
}
      </div>
    </div>
  </form>
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="saving" (click)="save()">
    @if (saving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
